<template>
  <div class="category">
    <div class="heading" @click="handleDropDownClick">
      <h4 class="title">{{ filtername }}</h4>
      <span
        :class="configuration[filtername].expanded ? 'up-arrow' : 'down-arrow'">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="inherit"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16.585 8.58496L12 13.17L7.415 8.58496L6 9.99996L12 16L18 9.99996L16.585 8.58496Z"
            fill="inherit" />
        </svg>
      </span>
    </div>
    <div v-if="configuration[filtername].expanded" class="content">
      <input
        :v-model="inputText"
        type="text"
        class="text-input"
        :placeholder="`Enter ${filtername}`"
        @input="handleChange"
        @keydown="nameKeydown($event)" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TextboxFilter",
  props: {
    filtername: {
      type: String,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputText: "",
    };
  },
  watch: {
    inputText(val) {
      this.name = val.replace(/\W/g, "");
    },
  },
  methods: {
    handleChange() {
      this.value = event.target.value;
      this.$emit("handleFilterChange", {
        type: "text",
        filterName: this.filtername,
        value: event.target.value,
      });
    },
    handleDropDownClick() {
      this.$emit("handleFilterToggle", `${this.filtername}`);
    },
    nameKeydown(e) {
      if (/^\W$/.test(e.key)) {
        e.preventDefault();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.text-input {
  background-color: var(--search-bar-bg);
  border: 0.0625rem solid var(--label-text);
  border-color: var(--tab-border);
  padding: 6px;
  margin: 10px 0;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  color: var(--primary-text);
}
</style>
